<template>
    <Head title="Authorization Log" />

    <AuthenticatedLayout>
        <template #header>
            <NavigationSettings />
        </template>

        <div class="p-6 bg-white">
            <h3 class="font-semibold text-xl text-gray-800 sm:leading-tight">
                Лог авторизаций <b v-if="user">{{ user.name }}</b>
            </h3>
            <div class="grid gap-4 grid-cols-9 mt-6 pb-2 font-semibold">
                <div class="col-span-2">Дата</div>
                <div>IP</div>
                <div class="col-span-6">User Agent</div>
            </div>
            <div class="grid gap-4 grid-cols-9 border-t py-2" v-for="row in authorization_log.data" :key="row.id">
                <div class="my-auto col-span-2">{{ moment(row.date).format('L LTS')}}</div>
                <div class="my-auto">{{ row.ip }}</div>
                <div class="my-auto col-span-6">{{ row.ua }}</div>
            </div>
            <Pagination class="mt-6" :links="authorization_log.links" />
        </div>
    </AuthenticatedLayout>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import NavigationSettings from '@/Components/Navigation/Settings';
import Pagination from "@/Components/Pagination";
import moment from 'moment';

export default {
    components: {
        Head,
        AuthenticatedLayout,
        NavigationSettings,
        Pagination,
    },
    props: {
        user: Object,
        authorization_log: Object,
    },
    methods: {
        moment
    },
}
</script>
